import React, { useState } from 'react';
import Fees from '../Fees/Fees';
import PendingFees from '../PendingFees/PendingFees';
import TransferFees from '../TransferFees/TransferFees';
import styles from './FeesTab.module.scss';

function FeesTab() {
	interface dataTypes {
		id: Number;
		menu: String;
	}
	const [selectedNav, setSelectedNav] = useState<Number>(1);
	const dataRef: dataTypes[] = [
		{
			id: 1,
			menu: 'Collection fees',
		},
		{
			id: 2,
			menu: 'Payout fees',
		},
		{
			id: 3,
			menu: 'Pending fees',
		},
	];
	return (
		<>
			<div className={styles.tabContainer}>
				{dataRef.map(({ id, menu }: dataTypes, i) => (
					<div
						key={i}
						onClick={() => {
							setSelectedNav(id);
						}}
						className={
							selectedNav === id ? styles.activeMenuItem : styles.subMenuItem
						}>
						{selectedNav === id ? (
							<div className={styles.activeItemColor}>{menu}</div>
						) : (
							<div style={{ color: 'rgba(10, 9, 3, 0.6)' }}>{menu}</div>
						)}
					</div>
				))}
			</div>

			<div>
				{selectedNav === 1 ? (
					<Fees />
				) : selectedNav === 2 ? (
					<TransferFees />
				) : selectedNav === 3 ? (
					<PendingFees title="pending fees"/>
				) : (
					''
				)}
			</div>
		</>
	);
}

export default FeesTab;
